import styled from 'styled-components'

export const setLocalStorage = (
	key: string,
	value: Record<string, any> | string,
) => {
	if (typeof value === 'string') {
		localStorage.setItem(key, value)
		return
	}
	localStorage.setItem(key, JSON.stringify(value))
}

export function getFromLocalStorage<T>(
	key: string,
	defaultValue?: never,
): T | null
export function getFromLocalStorage<T>(key: string, defaultValue: T): T
export function getFromLocalStorage<T>(
	key: string,
	defaultValue: T | null = null,
) {
	const localStorageValue = localStorage.getItem(key)
	try {
		const item = JSON.parse(localStorageValue || 'null')
		return item != null ? item : defaultValue
	} catch {
		return localStorageValue == null
			? defaultValue
			: (localStorageValue as unknown as T | null)
	}
}


